<script setup lang="ts">
import ReportSummaryIncompleteNotice from './ReportSummaryIncompleteNotice.vue'
import ReportSummaryTabs from './ReportSummaryTabs.vue'
import type { ImagesType } from 'Modules/types/generic/image/ImagesType'

interface PropTypes {
  images: ImagesType
  annotations
  loading
}

const props = defineProps<PropTypes>()
</script>

<template>
  <div id="summary-content h-full grow">
    <div>
     <ReportSummaryIncompleteNotice :images="props.images" />
    </div>
    <ReportSummaryTabs 
      :loading="props.loading" 
      :images="props.images" 
      :annotations="props.annotations" />
  </div>
</template>
